import { createSlice } from "@reduxjs/toolkit";
import {
fetchPracticeStatus,
updatePracticeStatus      
} from "./PracticeStatusActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";

const practiceStatus = createSlice({
  name: "practiceStatus",
  initialState: {
    isPracticeStatusLoading: false,
    practiceStatusData: [],
    practiceStatusErrMsg : "",
    practiceStatusError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPracticeStatus.pending, (state) => {
        state.isPracticeStatusLoading = true;
        state.practiceStatusError = null;
      })
      .addCase(fetchPracticeStatus.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isPracticeStatusLoading = false;
          state.practiceStatusErrMsg = getApiErrorMessage(action.payload.success);
        } else {
          state.isPracticeStatusLoading = false;
          state.practiceStatusData = action.payload.data.data.practiceStatusDto;
        }
      })
      .addCase(fetchPracticeStatus.rejected, (state, action) => {
        state.isPracticeStatusLoading = false;
        state.practiceStatusError = action.error.message;
      })
  },
});

const practiceStatusUpdate = createSlice({
  name: "practiceStatusUpdate",
  initialState: {
    isPracticeStatusLoading: false,
    practiceStatusUpdateData: [],
    practiceStatusUpErrMsg : "",
    practiceStatusError: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updatePracticeStatus.pending, (state) => {
        state.isPracticeStatusLoading = true;
        state.practiceStatusError = null;
      })
      .addCase(updatePracticeStatus.fulfilled, (state, action) => {
        if (!action.payload.success) {
          state.isPracticeStatusLoading = false;
          state.practiceStatusUpErrMsg = getApiErrorMessage(action.payload.success);
        } else {
          state.isPracticeStatusLoading = false;
          state.practiceStatusUpdateData = action.payload.data.data.statusResponseDTO;
        }
      })
      .addCase(updatePracticeStatus.rejected, (state, action) => {
        state.isPracticeStatusLoading = false;
        state.practiceStatusError = action.error.message;
      })
  },
});

export const practiceStatusReducers = practiceStatus.reducer;
export const practiceStatusUpdateReducers = practiceStatusUpdate.reducer;